(function () {
  'use strict';

  function initProductVideos() {
    document.querySelectorAll('[data-pp-product-video]').forEach(function (wrap) {
      if (wrap.dataset.ppVideoReady === 'true') return;

      var sources = [];
      try {
        sources = JSON.parse(wrap.getAttribute('data-pp-product-video') || '[]');
      } catch (e) {
        return;
      }

      if (!sources.length) return;

      var poster = wrap.getAttribute('data-pp-poster') || '';
      var autoplay = wrap.getAttribute('data-pp-autoplay') === 'true';

      var video = document.createElement('video');
      video.setAttribute('playsinline', '');
      video.setAttribute('controls', '');
      video.setAttribute('loop', '');
      video.setAttribute('preload', 'metadata');
      if (poster) video.setAttribute('poster', poster);
      if (autoplay) {
        video.setAttribute('autoplay', '');
        video.setAttribute('muted', '');
      }
      video.className = wrap.className.replace('pp-video-placeholder', 'pp-video-active');
      video.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;background:#0a0a0a;border-radius:inherit';

      sources.forEach(function (src) {
        var source = document.createElement('source');
        source.src = src.url;
        source.type = src.type || 'video/mp4';
        video.appendChild(source);
      });

      wrap.innerHTML = '';
      wrap.appendChild(video);
      wrap.dataset.ppVideoReady = 'true';
    });

    document.querySelectorAll('.pp-product-gallery .swiper-slide').forEach(function (slide) {
      var img = slide.querySelector('img[alt*="product video" i]');
      if (!img || slide.querySelector('video')) return;

      var mediaId = slide.getAttribute('data-media-id');
      var jsonEl = document.getElementById('pp-product-videos-data');
      if (!jsonEl || !mediaId) return;

      var videos = [];
      try {
        videos = JSON.parse(jsonEl.textContent || '[]');
      } catch (e) {
        return;
      }

      var match = videos.find(function (v) {
        return String(v.id) === String(mediaId);
      });
      if (!match || !match.sources || !match.sources.length) return;

      var video = document.createElement('video');
      video.setAttribute('playsinline', '');
      video.setAttribute('controls', '');
      video.setAttribute('loop', '');
      video.setAttribute('preload', 'metadata');
      if (match.poster) video.setAttribute('poster', match.poster);
      if (slide === slide.closest('.swiper-wrapper')?.firstElementChild) {
        video.setAttribute('autoplay', '');
        video.setAttribute('muted', '');
      }
      video.className = img.className;
      video.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;background:#0a0a0a';

      match.sources.forEach(function (src) {
        var source = document.createElement('source');
        source.src = src.url;
        source.type = src.type || 'video/mp4';
        video.appendChild(source);
      });

      img.replaceWith(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductVideos);
  } else {
    initProductVideos();
  }

  document.addEventListener('shopify:section:load', initProductVideos);
})();
